import './App.css';
import NearbeeeApp from './NearbeeeApp';
import Login from './Component/Login/Login';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ShopLogin from './Component/Login/ShopLogin';
import LoginShop from './Component/Login/LoginShop';
import ShopDashboard from './Component/dashboard_shop/ShopDashboard';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Menu from './Component/dashboard_shop/Menu/Menu';
import Offer from './Component/dashboard_shop/Offer/Offer';
import ProtectedRoute from './Component/ProtectedRoute';
import SplashScreen from './Component/Anemation/SplashScreen';
import { useState } from "react";
import Home from './Component/Home/Home';
import UserMenu from './Component/UserMenu/UserMenu';
import UserOffer from './Component/UserOffer/UserOffer';
import HotelList from './Component/HotelList/HotelList';
import HotelInfo from './Component/HotelInfo/HotelInfo';
import UserLogin from './Component/UserLogin/UserLogin';
import Bookingpage from './Component/Bookingpage/Bookingpage';
import { GoogleOAuthProvider } from "@react-oauth/google";
import Category from './Component/Category/Category';
import WalletPage from './Component/WalletPage/WalletPage';
import ServicesPage from './Component/Services/ServicesPage';
import NIPage from './Component/NI/NIPage';
import AdminDashboard from './Component/Admin/AdminDashboard';
import ProviderLogin from './Component/ProviderLogin/ProviderLogin';
import MallsPage from './Component/Malls/MallsPage';
import MallDetail from './Component/Malls/MallDetail';
import LandingPage from './Component/Landing/LandingPage';

function App() {
  const [showSplash, setShowSplash] = useState(true);

  const GoogleAuthWrapper = () => {
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <LoginShop />
      </GoogleOAuthProvider>
    )
  }

  return (
    <div>
      <div className={`splash-wrapper ${showSplash ? "" : "hidden"}`}>
        <SplashScreen onFinish={() => setShowSplash(false)} />
      </div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}>
            {/* Landing page — first thing users see */}
            <Route index element={<LandingPage />} />
            {/* Offers/Explore feed */}
            <Route path="userdashboard/explore" element={<UserOffer />} />
            <Route path="userdashboard/menu" element={<UserMenu />} />
            <Route path="userdashboard/category" element={<Category />} />
            <Route path="userdashboard/restaurants" element={<HotelList />} />
            <Route path="userdashboard/restaurants/info" element={<HotelInfo />} />
            <Route path="userdashboard/booking" element={<Bookingpage />} />
            <Route path="userdashboard/wallet" element={<WalletPage />} />
            <Route path="userdashboard/services" element={<ServicesPage />} />
            <Route path="userdashboard/ni" element={<NIPage />} />
            <Route path="userdashboard/malls" element={<MallsPage />} />
            <Route path="userdashboard/malls/:mallId" element={<MallDetail />} />
          </Route>
          <Route path='/userlogin' element={
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
              <UserLogin />
            </GoogleOAuthProvider>
          } />
          <Route path='/providerlogin' element={
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
              <ProviderLogin />
            </GoogleOAuthProvider>
          } />
          {/* <Route path='/loginpage' element={<ShopLogin />} /> */}
          <Route path='/shoplogin' element={<GoogleAuthWrapper />} />
          <Route path='/shopregister' element={<ShopLogin />} />

          {/* Protected routes */}
          <Route
            path='/shopowner/shopdashboard'
            element={
              <ProtectedRoute>
                <ShopDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path='/shopowner/shopdashboard/menulist'
            element={
              <ProtectedRoute>
                <Menu />
              </ProtectedRoute>
            }
          />
          <Route
            path='/shopowner/shopdashboard/offer'
            element={
              <ProtectedRoute>
                <Offer />
              </ProtectedRoute>
            }
          />
          <Route path='/admin' element={<AdminDashboard />} />
          <Route path='/preview' element={<NearbeeeApp />} />
        </Routes>
        <ToastContainer theme="dark" toastContainerClassName="custom-toast-container" />
      </BrowserRouter>
    </div>
  );
}

export default App;
